var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProgress4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #546f7b;\r\n      }\r\n\r\n      .cls-3 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #dce0e2;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25,
    cy: 25,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.9,28.9v-1.4c0,0,0-.2,0-.2l4-8.4c0-.1.1-.1.3-.1h1.7c.1,0,.2,0,.1.2l-3.9,8.4h0s2.8,0,2.8,0c0,0,.1,0,.1-.1v-3.1c0-.1,0-.2.2-.2h1.7c.1,0,.2,0,.2.2v3.1c0,0,0,.1.1.1h.9c.1,0,.2,0,.2.2v1.4c0,.1,0,.2-.2.2h-.9c0,0-.1,0-.1.1v1.6c0,.1,0,.2-.2.2h-1.7c-.1,0-.2,0-.2-.2v-1.6c0,0,0-.1-.1-.1h-4.8c-.1,0-.2,0-.2-.2Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse_4",
    className: "cls-4",
    cx: 242.8,
    cy: -62.2,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-3",
    "data-name": "Ellipse_4",
    className: "cls-2",
    cx: 313.8,
    cy: -62.2,
    r: 15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgress4);
export default __webpack_public_path__ + "static/media/icon-progress4.630c640f38057a1c340e2450f0a78137.svg";
export { ForwardRef as ReactComponent };